import { render, staticRenderFns } from "./ConfirmationSummaryRow.vue?vue&type=template&id=2c1ddc8e&scoped=true&"
import script from "./ConfirmationSummaryRow.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSummaryRow.vue?vue&type=style&index=0&id=2c1ddc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ddc8e",
  null
  
)

export default component.exports